import { render, staticRenderFns } from "./wx-confirm.vue?vue&type=template&id=14f33fe2&scoped=true&"
import script from "./wx-confirm.vue?vue&type=script&lang=js&"
export * from "./wx-confirm.vue?vue&type=script&lang=js&"
import style0 from "./wx-confirm.vue?vue&type=style&index=0&id=14f33fe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f33fe2",
  null
  
)

export default component.exports